/**
 * Recomputes a course's derived metrics (student count, "% preferencias logradas", criteria
 * balance) from its current student list - used to update the UI live while dragging students
 * between courses, before the move is saved as a new version. Mirrors the same computation
 * web-api-colegios's getResultVersion does server-side (see its own doc comment), so what the
 * counselor sees while dragging matches what they'll get back after saving.
 */
export const computeCourseMetrics = (students) => {
  const studentCount = students.length

  const withAchieved = students.filter(student => (student.preferencesAchievedCount || 0) > 0)
  const preferencesAchievedPercent = studentCount
    ? Math.round((withAchieved.length / studentCount) * 100)
    : null

  const criteriaBalance = {}
  students.forEach(student => {
    const scores = student.criteriaScores
    if (!scores) return
    Object.entries(scores).forEach(([dimension, value]) => {
      if (value === null || value === undefined) return
      criteriaBalance[dimension] = criteriaBalance[dimension] || {}
      const key = String(value)
      criteriaBalance[dimension][key] = (criteriaBalance[dimension][key] || 0) + 1
    })
  })

  return { studentCount, preferencesAchievedPercent, criteriaBalance }
}
